import {
  Article,
  ArticleCreate,
  ArticleUpdate,
  ArticlesResponse,
  CategoriesResponse,
  ReorderResponse,
} from '../types/article';

const API_BASE = '/api';

export async function getArticles(date?: string, limit: number = 10000): Promise<Article[]> {
  let url = `${API_BASE}/articles?skip=0&limit=${limit}`;
  if (date) {
    url += `&date=${date}`;
  }
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch articles');
  }
  const data: ArticlesResponse = await response.json();
  return data.articles;
}

export async function getArticle(id: number): Promise<Article> {
  const response = await fetch(`${API_BASE}/articles/${id}`);
  if (!response.ok) {
    throw new Error('Failed to fetch article');
  }
  return response.json();
}

export async function createArticle(data: ArticleCreate): Promise<Article> {
  const response = await fetch(`${API_BASE}/articles`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Failed to create article');
  }
  return response.json();
}

export async function updateArticle(id: number, data: ArticleUpdate): Promise<Article> {
  const response = await fetch(`${API_BASE}/articles/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error('Failed to update article');
  }
  const result = await response.json();
  return result.article;
}

export async function deleteArticle(id: number): Promise<void> {
  const response = await fetch(`${API_BASE}/articles/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error('Failed to delete article');
  }
}

export async function reorderArticles(articleIds: number[]): Promise<ReorderResponse> {
  const response = await fetch(`${API_BASE}/articles/reorder`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ article_ids: articleIds }),
  });
  if (!response.ok) {
    throw new Error('Failed to reorder articles');
  }
  return response.json();
}

export async function getCategories(): Promise<string[]> {
  const response = await fetch(`${API_BASE}/categories`);
  if (!response.ok) {
    throw new Error('Failed to fetch categories');
  }
  const data: CategoriesResponse = await response.json();
  return data.categories;
}

export async function checkHealth(): Promise<{ status: string }> {
  const response = await fetch('/health');
  if (!response.ok) {
    throw new Error('Health check failed');
  }
  return response.json();
}
